import React from 'react';
import './Hero.css';

function Hero() {
  const scrollToContact = () => {
    const element = document.getElementById('kontakt');
    if (element) {
      element.scrollIntoView({ behavior: 'smooth', block: 'start' });
    }
  };

  const heroBackground = {
    backgroundImage: `url(${process.env.PUBLIC_URL}/img/bg.jpg)`,
  };

  return (
    <section className="hero" style={heroBackground}>
      <div className="hero-gradient"></div>
      <div className="hero-overlay">
        <h1>Der gute Dienst am Ton.</h1>
        <p className="lead">
          Musikproduktionen in bester Qualität und Atmosphäre. <br />
          Tageslicht im Studio, Livemitschnitte vor Ort und gute Ohren...
        </p>
        <button className="btn-primary" onClick={scrollToContact}>Buchung anfragen</button>
      </div>
    </section>
  );
}

export default Hero;
